var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab-list',{attrs:{"tabList":_vm.tableData,"columns":_vm.columns}}),_c('tab-list-checkbox',{attrs:{"tabList":_vm.tableData,"columns":_vm.columns}}),_c('vxe-tab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }